<template>
  <div class="root">
    <FadeIn>
      <header class="header">
        <img class="header__main-image1" src="@/assets/images/main_image1.png" />
        <img class="header__main-image2" src="@/assets/images/main_image2.png" />
        <img class="header__main-image3" src="@/assets/images/main_image3.png" />
        <img class="header__main-image4" src="@/assets/images/main_image4.png" />
        <img class="header__main u-pc-only" src="@/assets/images/main_pc.svg" alt="Twitterで応援！ ちょこりんとるかっぷを応援しよう！" />
        <img class="header__main u-sp-only" src="@/assets/images/main_sp.svg" alt="Twitterで応援！ ちょこりんとるかっぷを応援しよう！" />
      </header>
      <p class="period">掲載期間：2021年11月26日(金)17：00~12月13日(月)17：00</p>
    </FadeIn>

    <FadeIn :delay="0" margin="78%">
      <div class="hashtag">
        <span>「#ちょこりんメガホビ」</span>
        <br/>
        <span>「#るかっぷメガホビ」</span>
        <br/>
        <span>「#chokorin」</span>
        <br/>
        <span>「#lookupfigure」</span>
      </div>

      <p class="campaign-text">
        のいずれかをつけて、<br/>「ちょこりん」か「るかっぷ」が<br/>映った写真や<br/>応援メッセージを<br/>Twitterで投稿しよう！<br/>
        <span>※メッセージのみでもキャンペーンへの参加は可能です</span>
      </p>
      <p class="campaign-annotation">
        (1)投稿されたすべての投稿を掲載しているわけではございません。<br/>(2)メガハウスの公式アカウントにてご紹介させていただく可能性がございます。
      </p>
    </FadeIn>

    <div class="content">
      <div class="content__title">
        <h3>応援ゲージが100%まで貯まると</h3>
        <img src="@/assets/images/content_title_pc.svg" alt="「メガホビ　ショッピングステーション」のアフタートークを公開！" />
        <img src="@/assets/images/content_title_sp.svg" alt="「メガホビ　ショッピングステーション」のアフタートークを公開！" />
      </div>

      <a
        class="content__shopping-station"
        href="https://megahobbyexpo.jp/2021online/"
        target="_blank"
      >メガホビ&nbsp;ショッピングステーションの<br/>詳細はこちら！</a>

      <div class="content__gage">
        <GageBar :value="getGageValue()" />
      </div>

      <div class="content__pre-release">
        <p class="content__pre-release__heading">{{ preReleaseText }}</p>
        <div class="content__pre-release__video">
          <iframe
            width="560"
            height="315"
            :src="youtubeSrc"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
          ></iframe>
        </div>
      </div>

      <Tweets
        :latest-data="latestData"
        :data="data"
        :is-requesting="isRequesting"
        @click-more="onClickMoreTweet"
        ref="tweets"
      />
    </div>

    <div class="product">
      <p class="product__heading">商品情報</p>

      <div class="product__chokorin">
        <img class="product__chokorin__heading" src="@/assets/images/chokorin.png" />
        <ul class="product__list">
          <li v-for="product in chokorinProducts">
            <div class="product__item">
              <div :class="`product__image product__image--${product.type}`">
                <img :src="require(`@/assets${product.image}`)" />
              </div>
              <span class="product__item__name">{{ product.name }}</span>
              <a class="product__item__link" :href="product.url" target="_blank">商品詳細はこちら</a>
            </div>
          </li>
        </ul>

        <a
          href="https://www.megahobby.jp/event/chokorin_sp/"
          class="product__list-link"
          target="_blank"
        >
          ちょこりんマスコット&nbsp;シリーズ一覧をチェック&nbsp;>>
        </a>
      </div>

      <div class="product__lookup">
        <img class="product__lookup__heading" src="@/assets/images/lookup.png" />
        <ul class="product__list">
          <li v-for="product in lookupProducts">
            <div class="product__item">
              <div :class="`product__image product__image--${product.type}`">
                <img :src="require(`@/assets${product.image}`)" />
              </div>
              <span class="product__item__name">{{ product.name }}</span>
              <a class="product__item__link" :href="product.url" target="_blank">商品詳細はこちら</a>
            </div>
          </li>
        </ul>

        <a
          href="https://www.megahobby.jp/event/lookup/"
          class="product__list-link"
          target="_blank"
        >
          るかっぷ&nbsp;シリーズ一覧をチェック&nbsp;>>
        </a>
      </div>

    </div>

    <FadeIn>
      <div class="megahobby">
        <img class="megahobby__title u-pc-only" src="@/assets/images/megahobby_pc.svg" />
        <img class="megahobby__title u-sp-only" src="@/assets/images/megahobby_sp.svg" />
        <a
          class="megahobby__link"
          href="https://megahobbyexpo.jp/2021online/"
          target="_blank"
        >
          <img src="@/assets/images/megahobby_expo.png" />
        </a>
      </div>
    </FadeIn>

    <footer class="footer">
      <div class="footer__copyright">
        &copy;吾峠呼世晴／集英社・アニプレックス・ufotable&emsp;<br class="u-sp-only"/>&copy;芥見下々／集英社・呪術廻戦製作委員会
      </div>
      <div class="footer__megahouse">
        <img src="@/assets/images/magahouse.png" />
        <p>
          Megahouse COPYRIGHT 2005-2021<br/>
          MEGAHOUSE CORPORATION. ALL RIGHTS RESERVED.<br/>
          ALL OTHER PRODUCTS ARE TRADEMARKS OF REGISTERED OF THEIR RESPECTIVE OWNERS
        </p>
      </div>
    </footer>
  </div>
</template>

<style lang="scss" src="@/scss/reset.scss" />
<style lang="scss" src="@/scss/common.scss" />
<style lang="scss" src="@/scss/app.scss" scoped />

<script>
import Axios from 'axios'
import gsap, { Power3 } from 'gsap'

import Tweets from './components/Tweets.vue'
import GageBar from './components/GageBar'
import FadeIn from './components/FadeIn'

import chokorinProducts from './json/chokorin_products.json'
import lookupProducts from './json/lookup_products.json'

const PERIOD_START_DATE = '2021/11/26 00:00:00'

const PRE_RELEASE_TEXT_LIST = {
  '2021/11/01 00:00': '特別に一部先行公開！',
  '2021/12/01 18:00': '皆さん、応援ありがとうございました！\n特別に一部先行公開！\n2021年12月3日 17:00 本公開予定！',
  '2021/12/03 17:00': '皆様、応援ありがとうございました！'
}

const GAGE_VALUES = {
  '2021/11/01 00:00': 0,
  '2021/11/26 17:30': 10,
  '2021/11/26 18:00': 20,
  '2021/11/26 18:30': 30,
  '2021/11/26 21:00': 40,
  '2021/11/28 21:00': 50,
  '2021/11/29 18:00': 60,
  '2021/11/30 18:00': 70,
  '2021/11/30 21:00': 80,
  '2021/12/01 14:00': 90,
  '2021/12/01 18:00': 100,
}

const TYPES = {
  kimetsu: 'kimetsu',
  jujutsu: 'jujutsu',
}

const YOUTUBE_BASE_URL = 'https://www.youtube.com/embed/'

const axios = Axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://api.shuttlerock.com' : '/'
})

export default {
  name: 'App',
  components: {
    Tweets,
    GageBar,
    FadeIn
  },
  data() {
    return {
      latestData: null,
      data: [],
      chokorinProducts,
      lookupProducts,
      page: 1,
      isRequesting: true,
      now: null,
      periodStart: null,
      TYPES
    }
  },
  created() {
    if (this.$route.query && this.$route.query.test_date) {
      this.now = new Date(this.$route.query.test_date.replace(/"/g, ''))
      this.periodStart = Math.floor((new Date('2021/10/01 18:05:00')).getTime() / 1000)
    } else {
      this.now = new Date()
      this.periodStart = Math.floor((new Date(PERIOD_START_DATE)).getTime() / 1000)
    }

    this.getTweets()
  },
  computed: {
    preReleaseText() {
      const textIndex = this.getPreReleaseTextIndex()
      const textKey = Object.keys(PRE_RELEASE_TEXT_LIST)[textIndex]
      return PRE_RELEASE_TEXT_LIST[textKey]
    },
    youtubeSrc() {
      const releaseIndex = this.getPreReleaseTextIndex()
      switch (releaseIndex) {
        case 0:
          return `${YOUTUBE_BASE_URL}${window.YOUTUBE_ID1}`
        case 1:
          return `${YOUTUBE_BASE_URL}${window.YOUTUBE_ID2}`
        case 2:
          return `${YOUTUBE_BASE_URL}${window.YOUTUBE_ID3}`
      }
      return `${YOUTUBE_BASE_URL}${window.YOUTUBE_ID1}`
    }
  },
  methods: {
    getPreReleaseTextIndex() {
      const now = this.now.getTime()

      let textIndex = 0
      Object.keys(PRE_RELEASE_TEXT_LIST).forEach((date, index) => {
        const dateTime = (new Date(date)).getTime()
        if (dateTime <= now) {
          textIndex = index
        }
      })

      return textIndex
    },
    getGageValue() {
      const now = this.now.getTime()

      let value = 0
      Object.keys(GAGE_VALUES).forEach((date) => {
        const dateTime = (new Date(date)).getTime()
        if (dateTime <= now) {
          value = GAGE_VALUES[date]
        }
      })

      return value
    },
    getTweets() {
      const params = {
        page: this.page,
        per_page: 13,
        created_after: this.periodStart,
        sort_method: 'created_desc'
      }
      axios.get('/v2/megahouse-cp-ycevqxg2it/boards/lp-d4c8d0be-51ec-4b1f-9394-f72557e8434e/entries.json', { params })
        .then(({ data }) => {
          if (data.length === 0) {
            this.$refs.tweets.setVisibleMore(false)
            this.isRequesting = false
            return
          }

          if (!this.latestData) {
            this.latestData = data[0]
            this.data = data.slice(1)
          } else {
            this.data = [
              ...this.data,
              ...data
            ]
          }
          this.isRequesting = false

          if (this.page === 1 || data.length === 0) {
            return
          }

          const tweets = this.$refs.tweets && this.$refs.tweets.$refs.tweets
          const scrollTo = tweets.scrollHeight

          this.$nextTick(() => {
            const duration = (scrollTo - tweets.scrollTop) / 2200
            const value = { scrollTop: tweets.scrollTop }
            gsap.fromTo(
              value,
              {},
              {
                scrollTop: scrollTo,
                ease: Power3.easeOut,
                duration,
                onUpdate: () => {
                  tweets.scroll(0, value.scrollTop)
                }
              }
            )
          })
        })
    },
    onClickMoreTweet() {
      this.page += 1
      this.isRequesting = true
      this.getTweets()
    }
  }
}
</script>
